"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Rozhranní pro přístup k pracovníkům. Generated from cz.marbes.api.organizace.v1.PracovnikService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-05-22T17:56:16Z                      #

// ##############################################################

var PracovnikApi = function () {
  function PracovnikApi() {
    (0, _classCallCheck3.default)(this, PracovnikApi);
  }

  (0, _createClass3.default)(PracovnikApi, null, [{
    key: "getPracovnikById",

    /**
     * Vrátí pracovníka s daným ID
     *
     * @param id ID pracovníka
     * @return pracovník
     */
    value: function getPracovnikById(id) {
      var uri = serverContextPath + ("/api/organizace/v1/pracovnici/" + id);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Fulltextové hledání pracovníků.
     *
     * @param fulltext fulltext řetězec
     * @param proSpustenouAplikaci pokud je true, hledá jen mezi pracovníky aktuýálně spuštěné aplikace, jinak hledá mezi všemi pracovníky
     * @param max maximální počet vrácených záznamů, max. však {@link #FULLTEXT_MAX}
     * @return nalezení pracovníci nebo prázdný seznam
     */

  }, {
    key: "findPracovnici",
    value: function findPracovnici(fulltext, proSpustenouAplikaci, max) {
      var uri = serverContextPath + "/api/organizace/v1/pracovnici";
      var headers = undefined;
      var params = { fulltext: fulltext, proSpustenouAplikaci: proSpustenouAplikaci, max: max };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Najde pracovníky s předanými ID.
     *
     * @param ids množina ID pracovníků
     * @return nalezení pracovníci
     */

  }, {
    key: "findPracovniciByIds",
    value: function findPracovniciByIds(ids) {
      var uri = serverContextPath + "/api/organizace/v1/pracovnici/byIds";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, ids, headers));
    }
  }]);
  return PracovnikApi;
}();

exports.default = PracovnikApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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